import React from 'react';
import cx from 'classnames';
import './style.scss';

interface I_SlideFooterProps {
    hide?: boolean;
    onlyRightBtn?: boolean;
    onClickLeftBtn: () => void;
    onClickRightBtn: () => void;
    leftBtnText: string;
    rightBtnText?: string;
    rightBtnClass?: any[];
    rightBtnJSX?: JSX.Element;
}

const SlideFooter: React.FC<I_SlideFooterProps> = (props) => {
    const moduleName = 'slidefooter';
    const {
        hide,
        onlyRightBtn,
        leftBtnText,
        rightBtnText,
        rightBtnClass,
        rightBtnJSX,
        onClickLeftBtn,
        onClickRightBtn,
    } = props;
    return (
        <div className={cx(`${moduleName}`, { tHide: hide })}>
            {!onlyRightBtn && (
                <div className={cx('leftBtn')} onClick={onClickLeftBtn}>
                    {leftBtnText}
                </div>
            )}
            <div className={cx('rightBtn', rightBtnClass)} onClick={onClickRightBtn}>
                {rightBtnJSX || rightBtnText}
            </div>
        </div>
    );
};

export default SlideFooter;
